import { Component, OnInit } from '@angular/core';

import { ArkUnitOfWork } from 'app/core/data/ark-unit-of-work';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService, SessionInformationService } from 'app/core/core.module';
import { Predicate } from 'breeze-client';
import { VisitDetailComponent } from '../visit-detail/visit-detail.component';
import moment from 'moment';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { DevExtremeModule, DxTemplateModule } from 'devextreme-angular';

@Component({
    selector: 'app-visit-list',
    standalone: true,
    templateUrl: './visit-list.component.html',
    styleUrls: ['./visit-list.component.scss'],
    imports: [DevExtremeModule, DxTemplateModule, RouterModule],
})
export class VisitListComponent implements OnInit {
    visits: any[];
    selectedMonth;

    constructor(
        private uow: ArkUnitOfWork,
        private sessionInfo: SessionInformationService,
        private modalService: BsModalService,
        public appInfo: AppInformationService,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.selectedMonth =
            this.sessionInfo.getItem('visits:selectedMonth') ||
            moment()
                .startOf('month')
                .toDate();
        this.getData();
    }

    monthChanged() {
        this.sessionInfo.setItem('visits:selectedMonth', this.selectedMonth);
        this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.visits = await this.uow.visits.where(
            new Predicate('date', '>=', this.selectedMonth).and(
                'date',
                '<',
                moment(this.selectedMonth)
                    .add(1, 'month')
                    .toDate()
            ),
            'date,person.lastName,person.firstName',
            'person,type,visitedBy'
        );
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e: any) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons'
        });
    }

    open(pledgeId?: number) {
        this.router.navigate(['./' + (pledgeId || 'new')], { relativeTo: this.route });
        // const modalRef = this.modalService.show(VisitDetailComponent, {
        //     class: 'modal-md',
        //     ignoreBackdropClick: true,
        //     keyboard: false,
        //     initialState: { pledgeId }
        // });

        // modalRef.content.result.subscribe(async result => {
        //     if (result.result) {
        //         this.getData();
        //     }
        // });
    }
}
